const config = {
  email: {
    apiUrl: '../.netlify/functions/sendEmail',
    addresses: [
      'caitlin@caitlinbaird.com',
    ]
  }
};

export default config;